import { useMemo } from "react"

import { UITypes } from "types"

import useUrlQueryParams from "hooks/useUrlQueryParams"

import { TableSelectContent } from "./TableSelectContent"

interface Props {
  headerCell: UITypes.TableHeaderCell
  isColorSelect?: boolean
}

export const TableSelect = ({ headerCell: { title, name, options }, isColorSelect = false }: Props) => {
  const { originalQueryParams, setUrlQueryParams } = useUrlQueryParams()

  const value = useMemo(() => {
    if (options) {
      const result = options.filter(item => item.value === originalQueryParams[name || ""])
      return result[0] || null
    }
    return null
  }, [originalQueryParams, options, name])

  const handleChange = (option: UITypes.Option | null) => {
    if (!name) return

    setUrlQueryParams({
      [name]: option?.value || null,
    })
  }

  return (
    <TableSelectContent
      name={name}
      options={options}
      placeholder={title}
      value={value}
      isColorSelect={isColorSelect}
      onChange={handleChange}
    />
  )
}
